export class AuditLogExtendedData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "auth",
            "baseName": "auth",
            "type": "AuditLogExtendedDataAuth",
            "format": ""
        },
        {
            "name": "mpa",
            "baseName": "mpa",
            "type": "AuditLogExtendedDataMpa",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogExtendedData.attributeTypeMap;
    }
    constructor() {
    }
}
